import * as api from '../api';

export const getUserSimple = async () => await api.get('/user/simple');
export const getAuthenticatedUser = async () => await api.get('/v5/users');

export const getHeadCoach = async () => await api.get('/v5/headCoach');

export const getById = async id =>
    console.error(
        'calling UserService.getById but method is not ported from ch yet'
    ); // we may not need to migrate this -aryn
// return await api.get('/3.0/coach/athlete/' + id); <-- a new route maybe.. -aryn

export const getAllCoaches = async () => await api.get('/1.0/admin/coach');

export const getCircuitNumbers = async (orgId, userId) =>
    await api.get(`/3.0/coach/athlete/numbers/circuits/${orgId}/${userId}`);

export const getNumbers = async (orgId, userId) =>
    await api.get(`/3.0/coach/athlete/numbers/${orgId}/${userId}`);

export const getAllRoles = async () => await api.get('/1.0/admin/user/roles');

export const getAllRolesWithUsers = async userId =>
    await api.get(`/1.0/admin/user/${userId}/roles`);

export const getNotesForOrg = async (orgId, userId) =>
    await api.get(`/2.0/coach/admin/note/${orgId}/${userId}`);

export const getPrefs = async () => await api.get('/2.0/coach/prefs');

export const getUserProfile = async userId =>
    await api.get(`/v5/users/${userId}`);

export const putNotesForOrg = async (orgId, userId, notesObj) =>
    await api.put(`/2.0/coach/admin/note/${orgId}/${userId}`, notesObj);

export const getWorkingMaxes = async (orgId, userId) =>
    await api.get(`/2.0/coach/admin/workingMax/${orgId}/${userId}`);

export const putWorkingMax = async (orgId, userId, wmId, value) =>
    await api.put(`/2.0/coach/admin/workingMax/${orgId}/${userId}/${wmId}`, {
        value
    });
